import { useRef, useEffect } from 'react';
import LoadingBar from 'react-top-loading-bar';
import fetchIntercept from 'fetch-intercept';

const TopLoadingBar = () => {
	const loadingBarRef: any = useRef(null);
	const skipLoadingCount = useRef(0);

	useEffect(() => {
		const unregister = fetchIntercept.register({
			request: (url, config) => {
				const headers = config?.headers;
				let skipLoading = false;

				if (headers instanceof Headers) {
					skipLoading = headers.has('x-skip-loading');
				}

				if (skipLoading) {
					skipLoadingCount.current++;
					return [url, config];
				}

				loadingBarRef?.current?.continuousStart();
				return [url, config];
			},

			requestError: (error) => {
				loadingBarRef?.current?.complete();
				return Promise.reject(error);
			},

			response: (response) => {
				if (skipLoadingCount.current > 0) {
					skipLoadingCount.current--;
					return response;
				}
				loadingBarRef?.current?.complete();
				return response;
			},

			responseError: (error) => {
				if (skipLoadingCount.current > 0) {
					skipLoadingCount.current--;
					return Promise.reject(error);
				}
				loadingBarRef?.current?.complete();
				return Promise.reject(error);
			},
		});

		return () => {
			unregister();
		};
	}, []);

	return <LoadingBar color="#1fb0e5" height={4} ref={loadingBarRef} />;
};

export default TopLoadingBar;
